import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Chip from "@mui/material/Chip";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import React from "react";
import { ICItemStatusEntry } from "../declarations/CItemStatusEntry";
import { getLatestCompletedStepLabel } from "../manufacturing/manufacturingPipeline";
import { getResolvedRedirectBaseUrl } from "@ntg/component-library/utilities";
import { useNavigate } from "react-router";

interface IManufacturingToolbarProps {
    DesignID: number;
    OrderItemID: number;
    Statuses: ICItemStatusEntry[];
}

export default function ManufacturingToolbar(
    props: Readonly<IManufacturingToolbarProps>,
) {
    const navigate = useNavigate();

    const latestStatus = getLatestCompletedStepLabel(props.Statuses);
    const hasProgress = latestStatus !== "Not Started";

    const csManufacturingItemUrl = `${getResolvedRedirectBaseUrl()}saildesign/Design.aspx?DesignID=${props.DesignID}`;

    return (
        <div
            style={{
                padding: "9px 3px 1px 3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
            }}
        >
            <Chip
                label={latestStatus}
                size="small"
                color={hasProgress ? "success" : "default"}
                variant={hasProgress ? "filled" : "outlined"}
                sx={{ fontWeight: 600 }}
            />

            <ButtonGroup
                variant="contained"
                size="small"
                color="info"
                aria-label="Explorer button group"
                sx={{ marginLeft: "auto" }}
            >
                <Button
                    onClick={() => {
                        navigate(`/explorer/Manufacturing/${props.OrderItemID}`);
                    }}
                    endIcon={<AccountTreeIcon />}
                >
                    Open in Explorer
                </Button>
            </ButtonGroup>

            <ButtonGroup
                variant="contained"
                size="small"
                color="warning"
                aria-label="CS links"
            >
                <Button
                    component="a"
                    href={csManufacturingItemUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    endIcon={
                        <OpenInBrowserIcon htmlColor="inherit !important" />
                    }
                >
                    CS Manufacturing Item
                </Button>
            </ButtonGroup>
        </div>
    );
}
